import BiorhythmPurpleImage from "@/assets/img/today/biorhythm/biorhythm_purple.webp"
import BiorhythmRedImage from "@/assets/img/today/biorhythm/biorhythm_red.webp"
import BiorhythmCyanImage from "@/assets/img/today/biorhythm/biorhythm_cyan.webp"

import { useHorizontalWheelScroll } from "../../hooks/use-horizontal-wheel-scroll"

type BiorhythmCycleCard = {
  title: string
  description: string
  cycleLength: number
  iconSrc: string
}

const CYCLE_CARDS: readonly BiorhythmCycleCard[] = [
  {
    title: "Physical",
    description:
      "The physical cycle regulates the strength, metabolic rate, sex drive, initiative, stamina, and eye and hand coordintaion.",
    cycleLength: 23,
    iconSrc: BiorhythmPurpleImage,
  },
  {
    title: "Emotional",
    description:
      "The emotional cycle influences mood, sensitivity, creativity, stress resistance, and how you react to interpersonal dynamics.",
    cycleLength: 28,
    iconSrc: BiorhythmRedImage,
  },
  {
    title: "Intellectual",
    description:
      "The intellectual cycle governs focus, memory, analytical thinking, learning ability, and decision-making. (33 days)",
    cycleLength: 33,
    iconSrc: BiorhythmCyanImage,
  },
] as const

/** Horizontal cards explaining the 3 biorhythm cycles. */
export function BiorhythmCycles() {
  const cyclesContainerRef = useHorizontalWheelScroll<HTMLDivElement>()

  return (
    <div className="mt-10 select-none">
      <div className="mb-6 px-4">
        <h2 className="mb-2 font-display text-2xl font-medium text-purple-light">Biorhythm cycles</h2>
        <p className="font-body text-base text-purple-light/70">
          Your body flows through three rhythms - physical, emotional, and intellectual - shaping your
          daily energy and focus.
        </p>
      </div>

      <div
        ref={cyclesContainerRef}
        className="flex w-full items-stretch gap-4 overflow-x-auto px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {CYCLE_CARDS.map((card) => (
          <div
            key={card.title}
            className="flex w-80 min-w-80 flex-col gap-4 rounded-3xl px-4 pb-6 pt-4"
            style={{
              background:
                "linear-gradient(225.93deg, rgba(223, 203, 245, 0.10) 0%, rgba(223, 203, 245, 0.05) 100%)",
            }}
          >
            <img src={card.iconSrc} alt={card.title} className="size-14" />

            <div className="flex flex-col gap-2">
              <h3 className="font-display text-xl font-medium text-purple-light">{card.title}</h3>
              <p className="font-body text-base text-purple-light/70">{card.description}</p>
            </div>

            <div className="mt-auto w-fit rounded-[23px] border border-purple-light/20 px-3 py-1.5 font-body text-sm text-purple-light/70">
              Cycle length: <span className="font-medium text-purple-light">{card.cycleLength} days</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
